import { ReactNode } from 'react';

export const bold = (text: ReactNode) => <strong>{text}</strong>;
export const colored = (color: string) => (text: ReactNode) =>
    <span style={{ color: color }}>{text}</span>;
export const intlLink = (link?: string) => (text: ReactNode) =>
    <a href={link ? link : text?.toString()}>{text}</a>;
export const phoneLink = (phoneNumber: ReactNode) =>
    intlLink(`tel:${phoneNumber}`)(phoneNumber);
